import Sortable from "sortablejs";
import initWidgets from "../initWidgets";

function reorder(formset) {
  formset.querySelectorAll("[data-order]").forEach((input, index) => {
    input.value = index + 1;
  });
}

function toggleAddButton(formset, prefix, addEmpty) {
  if (!addEmpty) return;
  const maxInput = formset.querySelector(`#id_${prefix}-MAX_NUM_FORMS`);
  if (!maxInput) return;
  const maxNum = parseInt(maxInput.value);
  const total = parseInt(
    formset.querySelector(`#id_${prefix}-TOTAL_FORMS`).value
  );
  const deleted = formset.querySelectorAll(
    'input[name$="-DELETE"]:checked'
  ).length;
  const active = total - deleted;
  addEmpty.closest("[data-form]").classList.toggle("hidden", active >= maxNum);
}

export function initFormset(formset) {
  const formsetList = formset.querySelector(".formset-list");
  const sortableList = formset.querySelector(".sortable");
  const addEmpty = formset.querySelector(".formset-add-empty");
  const prefix = formset.dataset.prefix;
  const totalFormsInput = formset.querySelector(`#id_${prefix}-TOTAL_FORMS`);

  if (sortableList) {
    /* eslint-disable no-new */
    new Sortable(sortableList, {
      handle: ".handle",
      animation: 150,
      ghostClass: "bg-brand-100",
      onEnd: (evt) => {
        reorder(sortableList);
        evt.target.closest("form").dispatchEvent(new Event("input"));
      },
    });
  }

  if (addEmpty) {
    addEmpty.addEventListener("click", (evt) => {
      evt.preventDefault();

      const formIndex = parseInt(totalFormsInput.value);
      const emptyForm = formset.querySelector(".empty-form").children[0];
      const newForm = emptyForm.cloneNode(true);
      newForm.innerHTML = newForm.innerHTML.replace(/__prefix__/g, formIndex);
      totalFormsInput.value = formIndex + 1;
      totalFormsInput.dispatchEvent(new Event("change"));
      formsetList.appendChild(newForm);

      if (sortableList) reorder(sortableList);
      initWidgets(newForm);
      toggleAddButton(formset, prefix, addEmpty);
      evt.target.closest("form").dispatchEvent(new Event("input"));
    });
  }

  formsetList.addEventListener("click", (evt) => {
    if (!evt.target.closest("[data-delete]")) {
      return;
    }
    evt.preventDefault();
    evt.target.closest("[data-form]").remove();
    totalFormsInput.value = parseInt(totalFormsInput.value) - 1;
    totalFormsInput.dispatchEvent(new Event("change"));
    toggleAddButton(formset, prefix, addEmpty);
  });

  formsetList.addEventListener("change", (evt) => {
    if (evt.target.matches('input[name$="-DELETE"]')) {
      toggleAddButton(formset, prefix, addEmpty);
    }
  });

  toggleAddButton(formset, prefix, addEmpty);
}
